module.exports = __webpack_public_path__ + "img/done_white_24dp.ce9d5e4d.svg";